export default {
  pending: 0,
  accepted: 1,
  rejected: 2,
  moreInfo: 3,
};
